export enum ServiceCode {
  storage = 'storage',
  k8s = 'k8s',
  loadbalancer = 'loadbalancer',
  restore_backup_as_new_vm = 'restore_backup_as_new_vm',
  increase_disk_limits = 'increase_disk_limits',
  update_master_node_config = 'update_master_node_config',
  monitoring = 'monitoring',
  alerts = 'alerts',
  dbaas = 'dbaas',
  vxlan = 'vxlan',
  asg = 'asg',
  routers = 'routers',
}

export type Service = {
  id: number,
  name: string,
  code: ServiceCode
  description: string,
  regionId: number,
  isDebugMode: boolean
};
